import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Tasks = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.26503 2.57601C4.4992 2.72236 4.57038 3.03084 4.42403 3.26501L3.17403 5.26501C3.08665 5.40481 2.93597 5.49256 2.77125 5.49956C2.60653 5.50655 2.44895 5.4319 2.35003 5.30001L1.60003 4.30001C1.43434 4.07909 1.47912 3.76569 1.70003 3.60001C1.92094 3.43432 2.23434 3.47909 2.40003 3.70001L2.71251 4.11664L3.57603 2.73501C3.72239 2.50084 4.03086 2.42965 4.26503 2.57601ZM6.44192 3.50001C6.16578 3.50001 5.94192 3.72386 5.94192 4.00001C5.94192 4.27615 6.16578 4.50001 6.44192 4.50001H14.1927C14.4688 4.50001 14.6927 4.27615 14.6927 4.00001C14.6927 3.72386 14.4688 3.50001 14.1927 3.50001H6.44192ZM6.44192 7.50001C6.16578 7.50001 5.94192 7.72386 5.94192 8.00001C5.94192 8.27615 6.16578 8.50001 6.44192 8.50001H14.1927C14.4688 8.50001 14.6927 8.27615 14.6927 8.00001C14.6927 7.72386 14.4688 7.50001 14.1927 7.50001H6.44192ZM5.94192 12C5.94192 11.7239 6.16578 11.5 6.44192 11.5H14.1927C14.4688 11.5 14.6927 11.7239 14.6927 12C14.6927 12.2761 14.4688 12.5 14.1927 12.5H6.44192C6.16578 12.5 5.94192 12.2761 5.94192 12ZM2.00003 7.50001C1.72389 7.50001 1.50003 7.72386 1.50003 8.00001C1.50003 8.27615 1.72389 8.50001 2.00003 8.50001H4.00003C4.27617 8.50001 4.50003 8.27615 4.50003 8.00001C4.50003 7.72386 4.27617 7.50001 4.00003 7.50001H2.00003ZM2.00003 11.5C1.72389 11.5 1.50003 11.7239 1.50003 12C1.50003 12.2761 1.72389 12.5 2.00003 12.5H4.00003C4.27617 12.5 4.50003 12.2761 4.50003 12C4.50003 11.7239 4.27617 11.5 4.00003 11.5H2.00003Z"
      />
    </svg>
  )
})

export default Tasks
